module.exports = __webpack_public_path__ + "static/media/corkease-5.9c0bf5b9.jpg";